import React, { useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import { Button, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'

import { selectUser } from '../../reducers/UserReducer'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import { createLinkRequest } from '../../utils/api/linkRequest'
import { HttpStatuses } from '../../utils/http'
import { onError } from '../../utils/apiHelper'
import Loading from '../../Components/shared/Loading'
import { DEFAULT_INFO_TOOLTIP_COLOR } from '../../Components/institution/Quotas/utils/Constants'
import { isObject } from '../../utils'

const LinkWithSchoolModal = ({ institution, visible, onClose, children }) => {
  const user = useSelector(selectUser)
  const t = useSelector(selectTranslate)

  const { allowLinkRequests, isSchoolLinked, loading } = useContext(RequestPortalContext)

  const [buttonProps, setButtonProps] = useState({
    loading: false,
    text: t('internship_request_portal.send_link_request_button'),
    disabled: false,
    style: { margin: '0 auto', display: 'block' }
  })

  const handleLinkRequestSend = () => {
    setButtonProps({ ...buttonProps, loading: true })

    if (user.school && institution) {
      const body = {
        source: user.school.id,
        target: institution.id
      }

      createLinkRequest(user, body)
        .then(response => {
          setButtonProps({
            ...buttonProps,
            loading: false,
            text: t('internship_request_portal.send_link_request_button_success'),
            disabled: true
          })
        }).catch(response => {
          if (response.status === HttpStatuses.CONFLICT) {
            onError(t('internship_request_portal.send_link_request_button_conflict'))
            setButtonProps({
              ...buttonProps,
              loading: false,
              disabled: true
            })
          }
        })
    }
  }

  return (
    <>
      {isObject(institution) && (
        <Modal
          visible={visible}
          title={t('internship_request_portal.internship_request')}
          onOk={onClose}
          onCancel={onClose}
          okText={t('common.ok')}
          cancelText={t('common.cancel')}
        >
          {loading && <Loading />}
          {!loading && !isSchoolLinked && !allowLinkRequests && (
            <>
              <div className='modal-inner-container'>
                <FontAwesomeIcon color={DEFAULT_INFO_TOOLTIP_COLOR} icon={faExclamationCircle} />
                <span> {t('internship_request_portal.school_is_not_linked', { name: institution.name })}.</span>
              </div>
              <br />
              <span> {t('internship_request_portal.institution_does_not_allow_internship_requests')}</span>
              <br />
              {institution.email && (
                <span>{t('internship_request_portal.contact_institution_email')} <b>{institution.email}.</b></span>
              )}
              {!institution.email && (
                <span>{t('internship_request_portal.contact_institution')}</span>
              )}
            </>
          )}
          {!loading && !isSchoolLinked && allowLinkRequests && (
            <>
              <div className='modal-inner-container'>
                <FontAwesomeIcon color={DEFAULT_INFO_TOOLTIP_COLOR} icon={faExclamationCircle} />
                <span> {t('internship_request_portal.school_is_not_linked', { name: institution.name })}.</span>
              </div>
              <br />
              <span> {t('internship_request_portal.institution_does_not_allow_internship_requests')}</span>
              <span> {t('internship_request_portal.institution_allows_link_requests')}</span>
              <br />
              <br />
              <span>{t('internship_request_portal.send_link_request')}</span>
              <br />
              <br />
              <Button type='primary' style={buttonProps.style} onClick={handleLinkRequestSend} loading={buttonProps.loading} disabled={buttonProps.disabled}>
                {buttonProps.text}
              </Button>
            </>
          )}
          {!loading && isSchoolLinked && (
            <>
              <div className='modal-inner-container'>
                <FontAwesomeIcon color={DEFAULT_INFO_TOOLTIP_COLOR} icon={faExclamationCircle} />
                <span> {t('internship_request_portal.school_is_linked', { name: institution.name })}.</span>
              </div>
              <br />
              <span>{t('internship_request_portal.regular_channels')}</span>
            </>
          )}
        </Modal>
      )}
      {children}
    </>
  )
}

export default LinkWithSchoolModal
